import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import gameActions from 'redux/actions/gameActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import TimerModal from 'views/modals/timer_modal'

class GameQuestionTimer extends PureComponent {

	saveTimer = value => {
		this.props.actions.save(this.props.id, value)
	}

	render() {
		return (
			<TimerModal
				max={90}
				min={0}
				step={5}
				value={this.props.value}
				saveHandler={this.saveTimer}
				cancelHandler={this.props.actions.closeModal}
				closeModalHandler={this.props.actions.closeModal}
			/>
		)
	}

}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: gameActions.cancelQuestionTimer,
		save: gameActions.saveQuestionTimer,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(GameQuestionTimer)

export { GameQuestionTimer }
